import React, {useContext} from 'react';
import {useTranslation} from 'react-i18next';
import {Container, Grid, Typography} from '@material-ui/core';

import TimezoneNote from 'components/TimezoneNote';
import Context from 'utils/Context';

import FilmInfos from './FilmInfos';
import Rencontre from './Rencontre';

const FilmContent = ({film, currentVodFilm, cinema, seances, rencontres, onSeanceClick}) => {
  const {modele} = useContext(Context);
  const {t} = useTranslation();

  const isInArea = cinema.local && !!film && seances.some(seance => seance.local);
  const shouldDisplayNoAccess = currentVodFilm ? false : !isInArea;

  return (
    <div className="page-cinema__content">
      <Container maxWidth="lg">
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} sm={12} md={12}>
            <FilmInfos
              vod={currentVodFilm}
              film={film}
              cinemaId={cinema.cinema_id}
              seancesFilm={seances}
              onSeanceClick={onSeanceClick}
            />
          </Grid>
          {shouldDisplayNoAccess && (
            <Grid item xs={12} sm={12} md={6}>
              <Typography variant="body1" className="blanc">
                {t('vous-n-avez-pas-acces-à-ces-seances')}
              </Typography>
            </Grid>
          )}
          {isInArea && (
            <Grid item xs={12} sm={12} md={6}>
              <div className="page-cinema__footer">
                <Grid container spacing={0}>
                  <Grid item xs={12}>
                    {rencontres.length > 0 && (
                      <Typography variant="h5" className="blanc">
                        {rencontres.length === 1
                          ? t('seance-suivie-dune-rencontre')
                          : t('seances-suivies-dune-rencontre')}
                      </Typography>
                    )}
                    {rencontres.length > 0 && (
                      <Grid container spacing={3}>
                        {rencontres.map(s => (
                          <Grid key={s.seance_id} item xs={12} xl={6}>
                            <Rencontre
                              key={s.seance_id}
                              onPay={() => onSeanceClick(s)}
                              seance={s}
                              intervenants={modele.intervenants}
                            />
                          </Grid>
                        ))}
                        {rencontres.length > 5 && <TimezoneNote timezone={cinema.zone_name} />}
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </div>
            </Grid>
          )}
        </Grid>
      </Container>
    </div>
  );
};

export default FilmContent;
